/* eslint-disable for-direction */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import deleteIcon from '../../assets/images/dashboard-business/deleteIcon.svg';
import {
  useGetAllStateWithSterlingBranchMutation,
  useGetStatesMutation,
} from '../../../features/businessRegistration/businessRegistrationSlice';
import { TStep3Branch, TStep3Info } from '../../../types';
import { decryptJson } from '../../../utils/decryptJson';
import { encryptData } from '../../../utils/encryptJson';
import { logUserOut } from '../../../utils/logUserOut';
// import AddBranchFormltd from './AddBranchFormltd';
import {
  getFromLocalStorageTrustee,
  setInLocalStorageTrustee,
} from '../../../utils/setRegInfoInLocalStorage';
import BusinessAddressForm from './BusinessAddressForm';
import BusinessAddressFilledForm from './BusinessAddressFilledForm';
import customToast, { ToastType } from '../../../components_/Toast';
// import AddedBusinessAddress from './AddedBusinessAddress';

type TProps = {
  step3Info: TStep3Info;
  setStep3Info: React.Dispatch<React.SetStateAction<TStep3Info>>;
  branches: TStep3Branch[];
  setStep3Branches: React.Dispatch<React.SetStateAction<TStep3Branch[]>>;
  setStep: React.Dispatch<React.SetStateAction<number>>;
  setCurrentBranch: React.Dispatch<React.SetStateAction<number>>;
  currentBranch: number;
  display: number;
  setDisplay: React.Dispatch<React.SetStateAction<number>>;
};
const BusinessAddress = ({
  setStep,
  branches,
  setStep3Branches,
  setStep3Info,
  currentBranch,
  setCurrentBranch,
  step3Info,
  setDisplay,
  display,
}: TProps) => {
  const storedValues = getFromLocalStorageTrustee('showAddBranchForm');
  const [showAddBranchForm, setShowAddBranchForm] = useState(
    storedValues ? JSON.parse(storedValues) : false,
  );
  const [no, setNo] = useState(1);
  const [states, setStates] = useState<any[]>([]);
  const [statesApiError, setStatesApiError] = useState(false);
  const [nearestStatesApiError, setNearestStatesApiError] = useState(false);
  const [nearestSterlingStates, setNearestSterlingStates] = useState<any[]>([]);

  useEffect(() => {
    setInLocalStorageTrustee({ prop: 'showAddBranchForm', value: showAddBranchForm });
    // localStorage.setItem('showAddBranchForm', JSON.stringify(showAddBranchForm));
  }, [showAddBranchForm]);

  const noOfBranches = step3Info.noOfBranch;
  const branchesNo = noOfBranches === '3 or more' ? 1000 : Number(noOfBranches);

  const [getStates, { isLoading: lgaLoading }] = useGetStatesMutation();
  const [getSterlingBankStates, { isLoading: branchLoading }] =
    useGetAllStateWithSterlingBranchMutation();
  const [showingBranch, setShowingBranch] = useState(false);
  useEffect(() => {
    const handleGetStates = async () => {
      try {
        const body = encryptData({});
        const data = (await getStates(body as any).unwrap()) as any;
        const res = decryptJson(data?.data);
        setStates(res);
      } catch (err: any) {
        logUserOut(err?.status);
        setStatesApiError(true);
      }
    };
    handleGetStates();
  }, []);

  useEffect(() => {
    const handleGetSterlingBankStates = async () => {
      try {
        const body = encryptData({});
        const data = (await getSterlingBankStates(body as any).unwrap()) as any;
        const res = decryptJson(data?.data);
        setNearestSterlingStates(res);
      } catch (err: any) {
        logUserOut(err?.status);
        setNearestStatesApiError(true);
      }
    };
    handleGetSterlingBankStates();
  }, []);

  useEffect(() => {
    if (statesApiError) {
      customToast(
        'An error occured while getting the states, please refresh',
        ToastType.error,
        '',
        10000,
      );
    }
    if (nearestStatesApiError) {
      customToast(
        'An error occured while getting the nearest states a sterling bank branch is located in, please refresh',
        ToastType.error,
        '',
        10000,
      );
    }
  }, [nearestStatesApiError, statesApiError]);

  return (
    <div className='w-full sl:w-[750px]'>
      {step3Info?.selectedLga ? (
        <BusinessAddressFilledForm
          info={step3Info}
          setInfo={setStep3Info}
          states={states}
          branches={branches}
          setBranches={setStep3Branches}
          nearestSterlingStates={nearestSterlingStates}
          setStep={setStep}
          showingBranch={showingBranch}
          lgaLoading={lgaLoading}
          branchLoading={branchLoading}
          setShowAddBranchForm={setShowAddBranchForm}
        />
      ) : (
        <BusinessAddressForm
          info={step3Info}
          setInfo={setStep3Info}
          states={states}
          branches={branches}
          setBranches={setStep3Branches}
          nearestSterlingStates={nearestSterlingStates}
          setStep={setStep}
          showingBranch={showingBranch}
          lgaLoading={lgaLoading}
          branchLoading={branchLoading}
          setShowAddBranchForm={setShowAddBranchForm}
          currentBranch={currentBranch}
          setCurrentBranch={setCurrentBranch}
          setDisplay={setDisplay}
        />
      )}
    </div>
  );
};

export default BusinessAddress;
